import { Injectable } from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class EarningClientService {

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Basket por id
     * @param id ID da Basket
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "renda-variavel/proventos-cliente/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Basket
     * @param id ID da Basket
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "renda-variavel/proventos-cliente"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete Basket
     * @param id ID do Basket
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "renda-variavel/proventos-cliente/"+id, { headers: this.authService.getAuthHeaders() });
    }

     /**
     * Cadastra Boleta do Cliente
     * @param params Json AporBoletate do Cliente
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "renda-variavel/proventos-cliente", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * AtualizaBasket
     * @param params Json Basket
     */
     update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "renda-variavel/proventos-cliente/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }
    

}
